import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { Outlet } from "react-router-dom";
import NotFoundPage from "shared/components/empty/NotFoundPage";
import { useHasPermission } from "shared/utils/PermissionUtils";

export const NoticeConfigurationPage: React.FC = () => {
  const isServiceUser = useHasPermission(PermissionTypeEnum.service);
  if (isServiceUser) {
    return <Outlet />;
  } else {
    return <NotFoundPage />;
  }
};
